<template>
    <div class="snow">
        <div class="fog f1"></div>
        <div class="fog f2"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    }
};
</script>

<style lang="stylus" scoped>
.snow
    position absolute
    top 0
    left 0
    size 100%
    .fog
        position absolute
        top 2rem
        left 0
        size 100%
        transform translate3d(100%, 0, 1px)
        background url('/img/xj/fog.png') 0 0/100% auto no-repeat
        animation fog 15s infinite linear
        &.f2
            top 6rem
            animation-delay 10s
</style>
